<template>
  <div :class="classes">
    <div class="text__text" v-html="content.text" />
  </div>
</template>

<script>
import contentComponent from "@/mixins/content";

export default {
  name: "c-text",
  mixins: [contentComponent],
};
</script>

<style lang="scss" scoped>
.c-text {
  background: #fff;
  font-weight: 300;
  padding: 2rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  max-width: 90%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  font-size: 1.125rem;

  @include media-breakpoint-down(xl) {
    font-size: 1rem;
    padding: 1.5rem;
  }
  @include media-breakpoint-down(lg) {
    font-size: 0.75rem;
    padding: 1rem;
  }

  &--centered {
    justify-content: center;
    text-align: center;
  }

  &--small {
    font-size: 1rem;
    padding: 1.5rem;

    @include media-breakpoint-down(xl) {
      font-size: 0.875rem;
      padding: 1.25rem;
    }
    @include media-breakpoint-down(lg) {
      font-size: 0.625rem;
      padding: 1rem;
    }
  }
  &--tiny {
    font-size: 0.875rem;

    @include media-breakpoint-down(xl) {
      font-size: 0.625rem;
    }
    @include media-breakpoint-down(lg) {
      font-size: 0.5rem;
    }
  }
  &--compact {
    padding: 1.75rem;

    @include media-breakpoint-down(xl) {
      padding: 1.25rem;
    }
    @include media-breakpoint-down(lg) {
      padding: 0.75rem;
    }
  }

  ::v-deep {
    p {
      margin: 0;

      + ul,
      + ol,
      + p {
        margin-top: 1em;

        @include media-breakpoint-down(xl) {
          margin-top: 0.75em;
        }
        @include media-breakpoint-down(lg) {
          margin-top: 0.5em;
        }
      }
    }

    ol,
    ul {
      padding: 0;
      margin: 0 0 0 1em;
    }

    b {
      font-weight: bold;
    }
  }
}
</style>
